<div class="modal-header" id="modalHeader">
  <h2 *ngIf="!showNote" class="modal-title">Can't find one of your data products?</h2>
  <h2 *ngIf="showNote" class="modal-title">Can't find one of your software products?</h2>
  <button (click)="dismiss()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true"></span>
  </button>
</div>
<div class="modal-body" id="modalBody">
  <p *ngIf="!showNote">If you can’t find your data product, check the following before contacting Support.</p>
  <p *ngIf="showNote">If you can’t find your product, check the following before contacting Support.</p>
  <p>
    <strong
      >Confirm that
      <a
        angulartics2On="click"
        angularticsAction="myproducts-dialog-mail-to-loggedin-user"
        angularticsCategory="myproducts"
        angularticsLabel="mail-to-loggedin-user"
        angularticsValue="{{ email }}"
        href="mailto:{{ email }}"
        target="_blank"
        >{{ email }}
      </a>
      can access the product.</strong
    >
    If your access is associated with a different email address, sign in with that account. Otherwise, contact an
    account admin within your organization to confirm that you have access.
  </p>
  <p>
    <strong>Confirm that your organization has an active product subscription.</strong> Once a subscription expires, you
    no longer have access to current or past versions.
  </p>
  <p *ngIf="showNote">
    NOTE: We are in the process of migrating all software updates to this site, but that process is not yet complete.
    Updates for products not available here can be found where you usually download them.
  </p>
  <p>
    <span *ngIf="!showNote"
      >If you have confirmed the above items and are still unable to find one of your data products,
      <strong>or</strong> you do not know the account admin for your organization,
    </span>
    <span *ngIf="showNote"
      >If you have confirmed the above items and are still unable to find one of your software products,
      <strong>or</strong> you do not know the account admin for your organization,
    </span>
    <a
      *ngIf="!showNote"
      angulartics2On="click"
      angularticsAction="myproducts-dialog-redirect-to-contact-support"
      angularticsCategory="myproducts"
      angularticsLabel="redirect-to-contact-support"
      angularticsValue="redirect:https://customer.precisely.com/"
      href="https://customer.precisely.com/"
      target="_blank"
    >
      create a customer case
    </a>
    <a
      *ngIf="showNote"
      angulartics2On="click"
      angularticsAction="cant-find-products-dialog-redirect-to-contact-sales"
      angularticsCategory="MySoftwareProducts"
      href="https://customer.precisely.com/"
      target="_blank"
    >
      create a customer case
    </a>
    (if you are a partner,
    <a href="https://partner.precisely.com" target="_blank">create a partner case</a>).
  </p>
</div>
